import React from 'react';
const FormValidityContext = /*#__PURE__*/React.createContext({
  onInvalid: () => {},
  onChange: () => {},
  stateRef: []
});
export function FormValidityProvider({
  children,
  onChange
}) {
  const [valid, setValid] = React.useState();
  const value = React.useMemo(() => {
    return {
      stateRef: [],
      onInvalid: () => {
        if (valid !== false) {
          setValid(false);
        }
      },
      onChange: () => {
        if (valid !== null) {
          setValid(null);
        } else {
          setValid(undefined);
        }
      }
    };
  }, [valid, setValid]);
  const validMap = {
    [true]: 'outline-success',
    [false]: 'outline-danger'
  };
  React.useEffect(() => {
    console.log("effect stateref", value.stateRef.join(", "));
    if (value.stateRef.every(a => a) && valid !== true) {
      setValid(true);
    }
  }, [value, valid]);
  React.useEffect(() => {
    if (valid === true || valid === false) {
      onChange && onChange(valid);
    }
  }, [valid]);

  //console.log("VALID (render)", valid)

  return /*#__PURE__*/React.createElement(FormValidityContext.Provider, {
    value: value
  }, children);
}
export function FormValidityReporter({
  valid,
  children
}) {
  const {
    onInvalid,
    onChange,
    stateRef
  } = React.useContext(FormValidityContext);
  stateRef.push(valid);
  React.useEffect(() => {
    if (valid === false) {
      onInvalid(valid);
    } else {
      onChange();
    }
  }, [valid]);
  if (valid === false) {
    return /*#__PURE__*/React.createElement("div", {
      className: "error"
    }, children);
  }
  return null;
}
/*
function FormValidityTest() {
  const [valid, setValid] = React.useState()
  return <div>
    {valid ? "valid" : "invalid"}
    <FormValidityProvider onChange={setValid}>
      <FormValidityTestContents/>
    </FormValidityProvider>
  </div>
}

function FormValidityTestContents() {
  const [test1, setTest1] = React.useState(false)
  const [test2, setTest2] = React.useState("")
  return <>
    <Form.Check value={test1} onChange={(e)=>setTest1(e.target.checked)}/>
    <FormValidityReporter valid={test1}>
      Check the box.
    </FormValidityReporter>
    <Form.Control type="text" value={test2} onChange={(e)=>setTest2(e.target.value)}/>
    <FormValidityReporter valid={test2.length > 0}>
      Type something.
    </FormValidityReporter>
  </>
}
*/